import { NNBSP } from './constants';
import { getSymbol } from './symbols';

export const getValueWithCurrency = (
  value: string | number,
  currency: string,
) => {
  return `${value || '0'}${NNBSP}${currency ? getSymbol(currency) : ''}`;
};
